import request from '@/router/axios';
const urlPrefix = ''

/**
 * 获取负责的客户
 * @param obj
 */
export  function getCusByUser(obj) {
  return request({
    url:urlPrefix+ '/cus/getCusByUser',
    method: 'get',
  })
}


/**
 * 获取客户下联系人信息 只取一个
 * @param obj
 */
export  function getCusContacts(obj) {
  return request({
    url:urlPrefix+ '/cus/contacts/'+obj,
    method: 'get',
    // data: obj
  })
}

/**
 * 首页-查询客户
 * @param data
 *  name
 *  flag
 */
export  function getUserCusList(data) {
  return request({
    url: '/PmsUser/getUserCusList',
    method: 'post',
    data
  })
}

export  function getUserCusListZz(data) {
  return request({
    url: '/PmsUser/getUserCusListZz',
    method: 'post',
    data
  })
}

/**
 * 首页-查询客户
 * @param data
 *  name
 *  flag
 */
export  function getAllCusList(data) {
  return request({
    url: '/PmsUser/getAllCusList',
    method: 'post',
    data
  })
}

/**
 * 首页-切换客户
 * @param data
 *  custId
 *  custName
 *  yearMonth
 */
export  function switchUser(data) {
  return request({
    url: '/PmsUser/switchUser',
    method: 'post',
    data
  })
}
// 调用老业务系统接口
export function getSysApi(url, params) {
  return request({
    url: '/accountCloud' + url,
    method: 'post',
    params: {
      aacode: 'invoice',
      ...params
    }
  });
}
